import { Navigate, useParams, useSearchParams } from 'react-router-dom'

// Route bridge: legacy /payments/:id deep-links now open the payment-detail
// drawer over the payments list instead of a standalone detail page.
export default function PaymentDetailPage() {
  const { id } = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()

  if (!id) {
    return <Navigate to='/payments' replace />
  }

  const next = new URLSearchParams()
  next.set('panel', 'detail')
  next.set('payment', id)

  if (searchParams.get('status') === '1') {
    next.set('detail_status', '1')
  }

  return <Navigate to={`/payments?${next.toString()}`} replace />
}
